export default __webpack_public_path__ + "static/media/wave.ed23a71a.png";